import {getDateTimeState, getStudents, setDateTimeState} from "../../network/Endpoint";
import {cloneDeep} from "lodash";
import {useEffect, useState} from "react";

const DateTimeState = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);

    useEffect(() => {
        const allowedDomains = ["dev-lms.arkmath.co.kr"]; // 허용할 도메인 목록
        const currentDomain = window.location.hostname; // 현재 도메인 가져오기

        if (!allowedDomains.includes(currentDomain)) {
            window.location.href = "https://aimathlms.i-scream.co.kr"; // 리다이렉트할 URL
        }
    }, []);


    const fetchGetDateTimeState = async (classId) => {
        try {
            const res = await getDateTimeState();

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                setStartDate(res.data.data.startDate);
                setEndDate(res.data.data.endDate);
                setStartTime(res.data.data.startTime);
                setEndTime(res.data.data.endTime);
            } else {
                alert(`ERROR: 로드중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 로드중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };

    const fetchSetDateTimeState = async (classId) => {
        try {
            const body = {
                startDate : startDate,
                endDate : endDate,
                startTime : startTime,
                endTime : endTime
            };
            const res = await setDateTimeState(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                alert("저장 완료");
            } else {
                alert(`ERROR: 로드중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 로드중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };

    useEffect(() => {
        fetchGetDateTimeState();
    }, [])

    useEffect(() => {
        fetchGetDateTimeState();
    }, []);

    return (
        <div style={{ padding: "20px" }}>
            <h2>📅 날짜 및 시간 설정</h2>

            <div>
                <label>시작 날짜 (MM-DD):</label>
                <input
                    type="text"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="예: 02-10"
                />
            </div>

            <div>
                <label>종료 날짜 (MM-DD):</label>
                <input
                    type="text"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="예: 02-15"
                />
            </div>

            <div>
                <label>시작 시간 (HH:mm:ss):</label>
                <input
                    type="text"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    placeholder="예: 09:00:00"
                />
            </div>

            <div>
                <label>종료 시간 (HH:mm:ss):</label>
                <input
                    type="text"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    placeholder="예: 18:00:00"
                />
            </div>

            <button onClick={fetchSetDateTimeState} style={{ marginTop: "10px", padding: "5px 10px" }}>
                저장하기
            </button>
        </div>
    );
}

export default DateTimeState;